import * as React from 'react';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import OofMailtip from '../components/OofMailtip';
import { RecipientMailtipInfo } from '../components/SingleRecipientAutomaticReplyDetails';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MailTipDetails from '../store/schema/MailTipDetails';

/**
 * returns InfoBarMessageViewState for automatic replies in case one or more recipients are sending automatic replies.
 * returns null if no user is sending an automatic reply.
 */
export default (
    automaticReplyInfos: MailTipDetails[],
    onRemove: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!automaticReplyInfos.length) {
        return null;
    }

    const recipientsInfo: RecipientMailtipInfo[] = automaticReplyInfos.map(automaticReplyInfo => ({
        recipient: automaticReplyInfo.recipient,
        automaticReply: automaticReplyInfo.message,
    }));

    return {
        key: 'AutomaticReply',
        messageElement: <OofMailtip recipientsInfo={recipientsInfo} onRemove={onRemove} />,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
